import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getCpdCategorysConfig from './getCpdCategorys';
import { apiAction as updateIndustryRoleApiAction, default as updateIndustryRoleConfig } from './updateIndustryRole';

const actions = createActions({
  USER: {
    API: {
      SET_CPD_CATEGORYS: apiResourceActionCreator('cpdCategorys')
    },
    SET_CPD_CATEGORYS: (payload) => (payload)
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.CpdCategorys), authToken, payload, actions.user.api.setCpdCategorys)

/**
 * Sets a user's areas of advice and updates their industry role.
 * After setting the areas of advice and updating their industry role, performs navigation
 * to the next step of on-boarding if there is no redirect flag set.
 */
export function* setCpdCategorys(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(updateIndustryRoleApiAction(authToken, action.payload.industry));
    yield put(apiAction(authToken, {
      industryId: action.payload.industryId,
      pendingCpdCategorys: action.payload.cpdCategorys
    }));

    const updateIndustryRoleResult = yield apiActionResult(updateIndustryRoleConfig.action.user.api.updateIndustryRole);
    const setCpdCategorysResult = yield apiActionResult(actions.user.api.setCpdCategorys);

    if (setCpdCategorysResult.success && updateIndustryRoleResult.success) {
      yield put(getCpdCategorysConfig.action.user.getCpdCategorys(action.payload.industry.userId));
      if (!action.payload.noRedirect) {
        yield put(push({ pathname: routes.app.dashboard }));
      }
    }
  }
}

const configuration = {
  name: 'setCpdCategorys',
  action: actions,
  sagas: setCpdCategorys,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true,
      error: null,
      setTrainingPlanSuccess: undefined
    }),
    success: (state, action) => ({
      ...state,
      cpdCategories: fp.map('cpdCategoryDetail')(action.payload.cpdCategorys.cpdCategorys),
      currentUserCpdCategorys: action.payload.cpdCategorys.cpdCategorys,
      currentUserTotalCpdCategorys: action.payload.cpdCategorys,
      setTrainingPlanSuccess: { success: true, info: 'Training Plan Updated' },
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      setTrainingPlanSuccess: { success: false, info: 'Training Plan Update Failed' },
      isUpdating: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/setCpdCategorys.js